import { render, staticRenderFns } from "./searchPolicy.vue?vue&type=template&id=22346bbe&scoped=true&"
import script from "./searchPolicy.vue?vue&type=script&lang=js&"
export * from "./searchPolicy.vue?vue&type=script&lang=js&"
import style0 from "./searchPolicy.vue?vue&type=style&index=0&id=22346bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22346bbe",
  null
  
)

export default component.exports